import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const usePageMeta = () => {
  const location = useLocation();

  useEffect(() => {
    const setMetaTags = () => {
      let title;
      let description;
      let url = window.location.href;

      switch (location.pathname) {
        case '/':
          title =
            'Home Page - Custom Logo Design for Business by Lincoln Book Publishers';
          description =
            'Welcome to the Home Page of Lincoln Book Publishers. We provide custom logo design services for businesses.';
          break;
        case '/thankyou':
          title =
            'Thank You - Custom Logo Design for Business by Lincoln Book Publishers';
          description =
            'Thank you for visiting Lincoln Book Publishers. We appreciate your business.';
          break;
        default:
          title = 'Custom Logo Design for Business by Lincoln Book Publishers';
          description =
            'Discover custom logo design services for businesses at Lincoln Book Publishers.';
      }

      document.title = title;

      return (
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:url" content={url} />
        </Helmet>
      );
    };

    setMetaTags();
  }, [location.pathname]);

  return null;
};

export default usePageMeta;
